import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChefHat, Menu, X } from 'lucide-react';
import { useAuthStore } from '../../store/useAuthStore';

export function MainNavigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const redirectToApp = useAuthStore((state) => state.redirectToApp);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const APP_URL = "https://app.menioo.com";
  
  const handleLoginClick = (e: React.MouseEvent) => {
    e.preventDefault();
    redirectToApp('/login');
  };
  
  const handleSignupClick = (e: React.MouseEvent) => {
    e.preventDefault();
    redirectToApp('/signup');
  };
  
  const handleAppRedirect = (e: React.MouseEvent) => {
    e.preventDefault();
    redirectToApp('/');
  };

  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16">
          {/* Left side: Mobile Menu Button + Logo */}
          <div className="flex items-center justify-between flex-1 md:justify-start md:space-x-2">
            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-menioo-navy hover:text-menioo-green transition-colors p-2"
                aria-expanded={isMenuOpen}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? (
                  <X className="h-6 w-6" />
                ) : (
                  <Menu className="h-6 w-6" />
                )}
              </button>
            </div>
        
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2" onClick={closeMenu}>
              <ChefHat className="h-8 w-8 text-menioo-green" />
              <span className="text-2xl font-display font-bold text-menioo-navy">
                Menioo
              </span>
            </Link>
        
            {/* Desktop Navigation Links */}
            <div className="hidden md:flex md:ml-8 space-x-4">
              <Link
                to="/why-menioo"
                className="text-menioo-navy hover:text-menioo-green transition-colors px-3 py-2"
              >
                Pourquoi Menioo
              </Link>
              <Link
                to="/pricing"
                className="text-menioo-navy hover:text-menioo-green transition-colors px-3 py-2"
              >
                Tarifs
              </Link>
              <a
                href="https://app.menioo.com/recipes"
                className="text-menioo-navy hover:text-menioo-green transition-colors px-3 py-2"
              >
                Explorer
              </a>
            </div>
          </div>

          {/* Desktop Auth Controls */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            {isAuthenticated ? (
              <a
                href={APP_URL}
                onClick={handleAppRedirect}
                className="bg-menioo-green text-white px-4 py-2 rounded-md hover:bg-menioo-green-dark transition-colors"
              >
                Aller sur Menioo
              </a>
            ) : (
              <>
                <a
                  href={`${APP_URL}/login`}
                  onClick={handleLoginClick}
                  className="text-menioo-navy hover:text-menioo-green transition-colors"
                >
                  Connexion
                </a>
                <a
                  href={`${APP_URL}/signup`}
                  onClick={handleSignupClick}
                  className="bg-menioo-green text-white px-4 py-2 rounded-md hover:bg-menioo-green-dark transition-colors"
                >
                  Commencer gratuitement
                </a>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100">
          <Link
            to="/why-menioo"
            className="block px-3 py-2 text-menioo-navy hover:text-menioo-green transition-colors"
            onClick={closeMenu}
          >
            Pourquoi Menioo
          </Link>
          <Link
            to="/pricing"
            className="block px-3 py-2 text-menioo-navy hover:text-menioo-green transition-colors"
            onClick={closeMenu}
          >
            Tarifs
          </Link>
          <a
            href="https://app.menioo.com/recipes"
            className="block px-3 py-2 text-menioo-navy hover:text-menioo-green transition-colors"
            onClick={closeMenu}
          >
            Explorer
          </a>
          
          {isAuthenticated ? (
            <a
              href={APP_URL}
              onClick={(e) => { closeMenu(); handleAppRedirect(e); }}
              className="block w-full text-center bg-menioo-green text-white px-4 py-2 mt-3 rounded-md hover:bg-menioo-green-dark transition-colors"
            >
              Aller sur Menioo
            </a>
          ) : (
            <div className="px-3 py-2 space-y-2">
              <a
                href={`${APP_URL}/login`}
                onClick={(e) => { closeMenu(); handleLoginClick(e); }}
                className="block text-menioo-navy hover:text-menioo-green transition-colors"
              >
                Connexion
              </a>
              <a
                href={`${APP_URL}/signup`}
                onClick={(e) => { closeMenu(); handleSignupClick(e); }}
                className="block w-full text-center bg-menioo-green text-white px-4 py-2 rounded-md hover:bg-menioo-green-dark transition-colors"
              >
                Commencer gratuitement
              </a>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}